var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseLoading(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3867 25.9218H13.6172V22.133C13.6172 21.6547 13.3408 21.2197 12.907 21.0179C12.4745 20.816 11.9614 20.8821 11.5961 21.1897L0.439852 28.6699C0.161027 28.9043 0 29.2491 0 29.6132C0 29.9772 0.161027 30.3222 0.43977 30.5564L11.596 38.0366C11.9615 38.3419 12.4697 38.4113 12.907 38.2085C13.3407 38.0066 13.6171 37.5716 13.6171 37.0934V33.3046H33.3866C34.0668 33.3046 34.6171 32.7542 34.6171 32.0741V27.1522C34.6172 26.4721 34.0668 25.9218 33.3867 25.9218ZM41.5602 11.4433L30.486 3.96315C30.1207 3.65553 29.6076 3.58941 29.1751 3.79129C28.7412 3.99325 28.4648 4.42827 28.4648 4.90651V8.69529H8.69531C8.01519 8.69529 7.46484 9.24563 7.46484 9.92575V14.8476C7.46484 15.5278 8.01519 16.0781 8.69531 16.0781H28.4648V19.8669C28.4648 20.3451 28.7412 20.7801 29.175 20.982C29.6122 21.1848 30.1204 21.1154 30.4859 20.8102L41.5602 13.33C41.8389 13.0957 41.9999 12.7507 41.9999 12.3867C41.9999 12.0226 41.839 11.6777 41.5602 11.4433Z",
    fill: "url(#paint0_linear_3171_168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3171_168",
    x1: 21,
    y1: 38.3237,
    x2: 21,
    y2: 3.67588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseLoading);
export default __webpack_public_path__ + "static/media/base_loading.7db5f407be70974919294297d1488720.svg";
export { ForwardRef as ReactComponent };